<!-- TODO: переписать этот компонент в рамках задачи CPME-3013 -->
<template>
  <cs-dialog v-model="shown">
    <dialog-default-layout>
      <template slot="title">
        <cs-spoiler v-model="spoilerShown" background="transparent">
          <div slot="header" class="spoiler-header">
            <h4 class="modal-title">{{ $t('transfer.for.what') }}</h4>
            <div class="modal-help-icon" :class="{ 'active': spoilerShown }"></div>
          </div>
          <div class="spoiler-body">
            <div class="modal-text">
              <p v-html="$t('product.description.is.important.for.tax.office')"></p>
            </div>
          </div>
        </cs-spoiler>
      </template>
      <div slot="content" class="modal-input">
        <cs-input
          v-model="description"
          :error="error"
          :title="$t('product.description.default')"
          :display-name="$t('product.description.default')"
          :placeholder="$t('for.example.master.class')"
          required
          @blur="handleBlur"
          @focus="handleFocus"
        />
      </div>
      <div slot="footer" class="modal-button-container">
        <button class="modal-button success" :disabled="isDisabled" @click="handleSave">
          {{ $t('common.apply') }}
        </button>
        <button class="modal-button cancel" @click="handleClose">
          {{ $t('common.cancel') }}
        </button>
      </div>
    </dialog-default-layout>
  </cs-dialog>
</template>

<script>
import { mapState } from 'vuex';

import DialogDefaultLayout from 'modules/Dialogs/DefaultLayout';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'DeclarationDescriptionModal',
  components: {
    DialogDefaultLayout,
  },
  props: {
    value: Boolean,
    project: Object,
  },
  created() {
    EVENT_BUS.$on('EVENT_SHOW_SPECIFICATION_OF_DECLARATION_DESCRIPTION', () => {
      this.error = false;
      this.shown = true;
    });
  },
  beforeDestroy() {
    EVENT_BUS.$off('EVENT_SHOW_SPECIFICATION_OF_DECLARATION_DESCRIPTION');
  },
  data() {
    return {
      shown: false,
      error: false,
      description: '',
      spoilerShown: false,
    };
  },
  computed: {
    preparedDescription() {
      return this.description.trim();
    },
    isValid() {
      return this.preparedDescription.length >= 1;
    },
    isDisabled() {
      return !this.isValid;
    },
    ...mapState(['SELECTED_TRANSACTION']),
  },
  watch: {
    value(val) {
      this.error = false;
      this.shown = val;
    },
    project(val) {
      this.description = val.declarationDescription;
    },
    shown(val) {
      this.$emit('input', val);
    },
  },
  methods: {
    handleSave() {
      this.SELECTED_TRANSACTION.description = this.description;
      EVENT_BUS.$emit('EVENT_START_DECLARATION');

      this.handleClose();
    },
    handleClose() {
      this.shown = false;
    },
    handleBlur() {
      this.error = !this.isValid;
    },
    handleFocus() {
      this.error = false;
    },
  },
};
</script>

<style lang="sass">
  .modal-input
    & .input
      margin-top: 0

      & > label
        &:before,
        &:after
          background-color: rgba(40, 41, 61, 0.75)
</style>

<style lang="sass" scoped>
  .spoiler-header
    position: relative
    margin-bottom: 20px

    +respond-to("small")
      margin-bottom: 10px

  .modal-help-icon
    width: 22px
    height: 22px
    position: absolute
    top: 7px
    right: 0
    background-image: url("~@/assets/img/icons/question.svg")
    background-repeat: no-repeat
    background-position: center
    cursor: pointer

    +respond-to("small")
      top: 50%
      transform: translateY(-50%)

    &.active
      background-image: url("~@/assets/img/icons/success.svg")

  .modal-title
    margin-bottom: 20px
    padding-right: 40px
    font-weight: 600
    font-size: 20px
    line-height: 30px
    color: #fff

    +respond-to("small")
      margin-bottom: 30px

  .modal-text
    margin-bottom: 20px
    font-weight: 500
    font-size: 14px
    line-height: 20px
    color: #fff
    opacity: .75

    span
      display: inline-block

    +respond-to("small")
      margin-bottom: 30px
      padding-right: 40px

      span
        display: inline

    p
      &:not(:last-child)
        margin-bottom: 20px

  .modal-input
    position: relative
    margin-bottom: 30px

    &:after
      content: ''
      width: 58px
      height: 60px
      position: absolute
      top: 50%
      right: -50px
      background-image: url("~@/assets/img/self-employed/description.svg")
      background-repeat: no-repeat
      background-position: center
      transform: translateY(-50%)

    img
      position: absolute
      right: -20px
      top: 50%
      transform: translateY(-50%)

  .modal-button-container
    display: flex
    flex-direction: column
    align-items: center

    +respond-to("small")
      flex-direction: row
      justify-content: space-between

  .modal-button
    width: 100%
    height: 50px
    font-weight: 600
    font-size: 18px
    line-height: 18px
    color: #fff
    border-radius: 50px

    &:hover(:not):disabled
      box-shadow: inset 0 -0.24rem 0 rgba(0, 0, 0, 0.2), 0 0.24rem 0.24rem rgba(124, 179, 66, 0.2)

    &.success
      flex: none
      margin-bottom: 20px
      background-color: #7CB342
      box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.25)

      +respond-to("small")
        width: 270px
        margin-bottom: 0

    &.cancel
      background: #181823

      +respond-to("small")
        width: 110px

    &:disabled,
    &.disabled
      color: #fff
      background-color: #3A3949
      box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.25)
      opacity: .5
      cursor: not-allowed
</style>
